import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDrag } from 'react-use-gesture'
import { onKeyDown } from '../../../service';
import LessonViewer from '../../lms-shared/LessonViewer/LessonViewer';
import ShareProjectBtn from '../../UI/ShareProjectBtn';
import Projects from '../Projects/Projects';
import classes from './Popup.module.css'
import Draggable from 'react-draggable';

const Popup = ({ lessonId, studyGroupId, saveProjectCallback, selectedAssessmentId }) => {
    const PopupSizeEnum = {
        small: 1,
        medium: 2,
        large: 3
    }
    const [popUpSize, setPopUpSize] = useState(PopupSizeEnum.medium);
    const robotImg = useSelector(state => state.application.robotImg);
    const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });


    const Medimize = () => {
        setPopUpSize(PopupSizeEnum.medium);
        setPopupPosition({ x: 0, y: 0 });
    };

    const Minimize = () => {
        setPopUpSize(PopupSizeEnum.small);
        setPopupPosition({ x: 0, y: 0 });
    };

    const Maximize = () => {
        setPopUpSize(PopupSizeEnum.large);
        setPopupPosition({ x: 0, y: 0 });
    };

    const handleDrag = (_, data) => {
        setPopupPosition({ x: data.x, y: data.y });
    };

    return (
        <Draggable
            position={popupPosition}
            onDrag={handleDrag}
            bounds="parent"
        >
            <div style={{ position: 'absolute', top: popUpSize == PopupSizeEnum.small ? 'calc(100vh - 120px)' : popUpSize == PopupSizeEnum.large ? 50 : 100, right: 0 }}>
                <div className={`${classes.PopUp} ${popUpSize == PopupSizeEnum.large && classes.LargePopUp} ${popUpSize == PopupSizeEnum.small ? classes.Active : ''}`} >
                    {popUpSize == PopupSizeEnum.small && <div className={classes.ClosedPopup}
                        style={{ position: 'relative', backgroundImage: `url(${robotImg})` }}>
                        <div className={classes.MovePopup}></div>
                        <div className={`${classes.Icon} ${classes.PlusCircle}`} onClick={Medimize} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, Medimize)}>
                            <div className={classes.Plus}></div>
                            <div className={`${classes.Plus} ${classes.Rotate}`}></div>
                        </div>
                        <div className={classes.SmallDotsImg}>  </div>
                    </div>}
                    {popUpSize != PopupSizeEnum.small && <div className={classes.OpenPopup}>

                        <div className={classes.Bot} style={{ backgroundImage: `url(${robotImg})` }}></div>
                        <div className={classes.Content}>
                            <LessonViewer ProjectsComm={Projects} lessonId={lessonId} studyGroupId={studyGroupId} saveProjectCallback={saveProjectCallback} shareBtn={ShareProjectBtn} selectedAssessmentId={selectedAssessmentId} />
                        </div>
                        <div className={classes.Icons}>
                            {popUpSize == PopupSizeEnum.medium ?
                                <div className={` ${classes.LargeIcon}`} onClick={Maximize} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, Minimize)}> </div> :
                                <div className={` ${classes.MediumIcon}`} onClick={Medimize} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, Minimize)}> </div>}
                            <div className={` ${classes.MinusCircle}`} onClick={Minimize} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, Minimize)}>  </div>
                        </div>
                        <div className={classes.DotsImg}>  </div>
                    </div>}
                </div>
            </div>
        </Draggable>
    )
}

export default Popup;